import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import useRebrandVersion from 'hooks/useRebrandVersion'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

/**
 * Keeps the document palette scope aligned with client-side experiment overrides.
 * Uses a layout effect so body class updates before paint when the override flips,
 * matching structural reads of useRebrandVersion() in the same commit.
 */
function usePaletteVersionBodyClass() {
  const rebrandVersion = useRebrandVersion()

  useIsomorphicLayoutEffect(() => {
    document.body.classList.toggle(REBRAND_PALETTE_CLASS, rebrandVersion === 'rebrand')
  }, [rebrandVersion])
}

export default usePaletteVersionBodyClass
